module.exports = __webpack_public_path__ + "img/layout9_preview.362e2cd1.jpg";